function clampTextToLines(element, maxLines, buttonEl) {
    const style = getComputedStyle(element);
    const lineHeight = parseFloat(style.lineHeight);
    if (isNaN(lineHeight) || lineHeight === 0) return;

    const maxHeight = lineHeight * maxLines;
    const originalText = element.dataset.originalText || element.innerText.trim();

    // reset text and remove existing Learn More before recalculating
    if (buttonEl) {
        buttonEl.remove();
    }
    element.innerText = originalText;

    let low = 0;
    let high = originalText.length;
    let result = originalText;

    if (element.scrollHeight <= maxHeight) {
        element.dataset.originalText = originalText;
        return;
    }
    while (low < high) {
        const mid = Math.floor((low + high) / 2);
        element.innerText = originalText.slice(0, mid) + '…';

        if (element.scrollHeight <= maxHeight) {
            low = mid + 1;
            result = element.innerText;
        } else {
            high = mid;
        }
    }

    element.innerText = result;
    element.dataset.originalText = originalText;
}

function autoClampText(element, lines = 5, buttonEl) {
    const applyClamp = () => {
        const card = element.closest('.card');
        if (card && card.classList.contains('card--expanded')) {
            return;
        }

        clampTextToLines(element, lines);

        if (buttonEl) {
            const originalText = element.dataset.originalText || element.innerText.trim();
            const isTruncated = element.innerText.trim() !== originalText.trim();

            if (isTruncated) {
                if (!element.contains(buttonEl)) {
                    element.append(' ');
                    element.appendChild(buttonEl);
                }
            } else {
                buttonEl.remove();
            }
        }
    };

    const resizeObserver = new ResizeObserver(applyClamp);
    resizeObserver.observe(element);
    window.addEventListener('resize', applyClamp);
    applyClamp();
}

export function testimonialsSection() {
    const videos = document.querySelector('#testimonials-videos-flick');
    if (videos) {
        const flickingVideos = new Flicking('#testimonials-videos-flick', {
            bound: true,
            inputType: ['pointer'],
        });
        let panelToTranslateInfo = flickingVideos.camera.visiblePanels[0];
        let infoInner = panelToTranslateInfo.element.querySelector('.info-inner');
        flickingVideos.on('visibleChange', (e) => {
            panelToTranslateInfo = e.visiblePanels[0];
            infoInner = panelToTranslateInfo.element.querySelector('.info-inner');
        });
        flickingVideos.on('move', (e) => {
            const panelInfoTranslate = e.axesEvent.pos.flick - flickingVideos.camera.range.min - panelToTranslateInfo._pos;
            const translateLimited = Math.min(Math.max(0, panelInfoTranslate), panelToTranslateInfo.size - infoInner.clientWidth);
            panelToTranslateInfo.element.firstElementChild.style.setProperty('--translate', `${translateLimited}px`);
        });
    }

    const cards = document.querySelector('#testimonials-cards-flick');
    if (cards) {
        const flickingCards = new Flicking('#testimonials-cards-flick', {
            bound: true,
            inputType: ['pointer'],
            align: 'prev',
            moveType: window.innerWidth < 960 ? 'snap' : 'freeScroll',
        });

        // Track current expansion operation to cancel stale ones
        let currentExpandId = 0;

        cards.querySelectorAll('.text').forEach((el) => {
            // Add "Learn More" button
            const button = document.createElement('button');
            button.type = 'button';
            button.innerText = 'Learn More';
            button.setAttribute('class', 'learn-more-button');

            button.addEventListener('click', async (e) => {
                // Prevent propagation to Flicking
                e.stopPropagation();
                e.preventDefault();

                // Increment and capture current operation ID
                const thisExpandId = ++currentExpandId;
                const card = el.closest('.card');
                const slide = el.closest('.flicking-slide');
                const originalText = el.dataset.originalText || el.innerText.trim();

                if (card) {
                    card.classList.add('card--expanded');
                }
                if (slide) {
                    slide.classList.add('flicking-slide--expanded');
                }

                button.remove();

                if (!slide) return;

                // Skip expansion/scrolling logic on mobile
                if (window.innerWidth < 960) {
                    el.innerText = originalText;
                    return;
                }

                // Calculate optimal width to maintain similar height
                const viewportWidth = cards.clientWidth;
                const baseWidth = slide.clientWidth;
                const cardHeight = el.offsetHeight;

                // Create a hidden clone to measure width with full text
                const measure = document.createElement('div');
                const styles = getComputedStyle(el);
                measure.style.cssText = `
                    position: absolute;
                    visibility: hidden;
                    font-size: ${styles.fontSize};
                    font-family: ${styles.fontFamily};
                    font-weight: ${styles.fontWeight};
                    line-height: ${styles.lineHeight};
                    padding: ${styles.padding};
                    box-sizing: ${styles.boxSizing};
                `;
                measure.innerText = originalText;
                document.body.appendChild(measure);

                // Edge offsets (must match values used later for positioning)
                const edgeOffsetLeft = 60;
                const edgeOffsetRight = 150;

                // Define search bounds - max width accounts for both edge offsets
                const minWidth = baseWidth;
                const maxWidth = viewportWidth - edgeOffsetLeft - edgeOffsetRight;

                // Binary search with iteration limit for safety
                let left = minWidth;
                let right = maxWidth;
                let optimalWidth = maxWidth;

                const tolerance = cardHeight * 0; // 0% tolerance
                const maxIterations = 25;

                for (let i = 0; i < maxIterations && right - left > 5; i++) {
                    const mid = Math.floor((left + right) / 2);
                    measure.style.width = `${mid}px`;
                    const measuredHeight = measure.offsetHeight;

                    if (measuredHeight <= cardHeight + tolerance) {
                        // This width works, try narrower
                        optimalWidth = mid;
                        right = mid;
                    } else {
                        // Too tall, need wider
                        left = mid + 1;
                    }
                }

                document.body.removeChild(measure);

                // Calculate width change and proportional duration
                const widthChange = optimalWidth - baseWidth;
                // Duration: min 0ms, max 600ms, scaled by width change (100px = ~150ms)
                const widthTransitionDuration = Math.min(600, Math.max(0, widthChange * 1.5));

                // Set CSS variable for transition duration
                slide.style.setProperty('--expand-duration', `${widthTransitionDuration}ms`);

                const panel = flickingCards.panels.find((p) => p.element === slide);
                const slidePos = panel.position;

                slide.style.width = `${optimalWidth}px`;

                // Text reveal timeout scales with width transition duration
                const textRevealDelay = Math.max(350, widthTransitionDuration * 0.7);
                setTimeout(() => {
                    el.innerText = originalText;

                    if (card) {
                        card.style.width = '100%';
                    }
                }, textRevealDelay);

                // Check if this operation is still current
                if (thisExpandId !== currentExpandId) return;

                requestAnimationFrame(async () => {
                    // Resize Flicking to account for width change
                    await flickingCards.resize().catch((e) => {
                        console.error('Error resizing Flicking:', e);
                    });

                    // Current camera left edge
                    const cameraPos = flickingCards.camera.position;
                    const viewportLeft = cameraPos;
                    const viewportRight = cameraPos + viewportWidth;

                    // Card boundaries
                    const cardLeft = slidePos;
                    const cardRight = slidePos + optimalWidth;

                    const isFullyVisible = cardLeft >= viewportLeft && cardRight <= viewportRight - edgeOffsetRight;

                    if (isFullyVisible) {
                        await new Promise((resolve) => setTimeout(resolve, widthTransitionDuration));
                    } else {
                        // Calculate minimum scroll needed to make card fully visible
                        // Only scroll as much as necessary
                        let targetCameraPosition = cameraPos;

                        const leftOverflow = viewportLeft + edgeOffsetLeft - cardLeft;
                        const rightOverflow = cardRight - (viewportRight - edgeOffsetRight);

                        if (rightOverflow > 0 && leftOverflow <= 0) {
                            // Card extends past right edge - scroll right (increase camera position)
                            targetCameraPosition = cameraPos + rightOverflow;
                        } else if (leftOverflow > 0 && rightOverflow <= 0) {
                            // Card extends past left edge - ignore
                            // targetCameraPosition = cameraPos - leftOverflow;
                        } else if (leftOverflow > 0 && rightOverflow > 0) {
                            // Card is wider than viewport - prioritize showing right edge
                            targetCameraPosition = cameraPos + rightOverflow;
                        }

                        // Clamp to minimum only (we handle max separately for expanded cards)
                        const clampedPosition = Math.max(flickingCards.camera.range.min, targetCameraPosition);

                        // Calculate scroll duration proportional to distance
                        const scrollDistance = Math.abs(clampedPosition - cameraPos);
                        // Duration: min 0ms, max 600ms, scaled by distance (100px = ~150ms)
                        const scrollDuration = Math.min(600, Math.max(0, scrollDistance * 1.5));

                        // Temporarily disable bound to allow moving beyond normal range
                        const needsUnbound = clampedPosition > flickingCards.camera.range.max;
                        if (needsUnbound) {
                            flickingCards.bound = false;
                            await flickingCards.resize();
                        }

                        // Use requestAnimationFrame for smoother animation start
                        await new Promise((resolve) => requestAnimationFrame(resolve));

                        await flickingCards.control.moveToPosition(clampedPosition, scrollDuration).catch((e) => {
                            console.error('Error moving camera:', e);
                        });

                        // Re-enable bound after movement completes
                        if (needsUnbound) {
                            flickingCards.bound = true;
                        }
                    }

                    // Debounce the final resize - do it after animations settle
                    await new Promise((resolve) => setTimeout(resolve, 50));
                    if (thisExpandId !== currentExpandId) return;

                    // Single resize at the end to update positions
                    await flickingCards.resize().catch((e) => {
                        console.error('Error resizing Flicking:', e);
                    });
                });
            });
            autoClampText(el, 5, button);
        });
    }
}
